module.exports = __webpack_public_path__ + "img/fi.a814e980.svg";